function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import icons from '../../icons.json';
import createElement from './utils/createElement';
import { iconSize } from './utils/styledSystemProps';
import Svg from '../Svg/Svg';

const Base = ({
  name,
  stroke,
  strokeWidth,
  strokeLinejoin,
  fill,
  strokeLinecap,
  ...props
}) => {
  const icon = icons[name];
  if (!icon) return false;
  const {
    children,
    fill: iDefaultFill,
    strokeWidth: iDefaultStrokeWidth,
    strokeLinecap: iDefaultStrokeLinecap,
    strokeLinejoin: iDefaultStrokeLineJoin,
    viewBox
  } = icon;
  const fillProp = fill || iDefaultFill;
  const strokeLinecapProp = strokeLinecap || iDefaultStrokeLinecap;
  const strokeWidthProp = strokeWidth || iDefaultStrokeWidth;
  const strokeLinejoinProp = strokeLinejoin || iDefaultStrokeLineJoin;
  return React.createElement(Svg, _extends({}, props, {
    stroke: stroke,
    strokeWidth: strokeWidthProp,
    strokeLinecap: strokeLinecapProp,
    strokeLinejoin: strokeLinejoinProp,
    viewBox: viewBox,
    fill: fillProp
  }), React.createElement("title", null, name), createElement(children));
};

const Icon = styled(Base).withConfig({
  displayName: "Icon",
  componentId: "sc-1u098or-0"
})(["flex:none;vertical-align:middle;", ";"], iconSize);
Icon.defaultProps = {
  iconSize: 2
};
Icon.displayName = 'Icon';
const keys = Object.keys(icons);
Icon.propTypes = {
  /** Height and width of the Icon */
  iconSize: PropTypes.number,

  /** Stroke of the Icon */
  stroke: PropTypes.string,

  /** Fill of the Icon */
  fill: PropTypes.string,

  /** Name of the Icon you want to render */
  name: ({
    name
  }) => {
    if (!keys.includes(name)) {
      return new Error(`Failed prop type: ${name} provided, expected one of ${keys.toString()}`);
    }

    return null;
  }
};
Base.propTypes = Icon.propTypes;
export default Icon;